
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */
import { Avatar, Category } from '@drawbotics/react-drylus';
import Playground from '~/components/Playground';


const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


<h1>{`Avatar`}</h1>
<p>{`Usage`}</p>
<pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`import { Avatar } from '@drawbotics/react-drylus';
`}</code></pre>
<p><strong parentName="p">{`Example`}</strong></p>
<Playground __position={0} __code={`<Avatar text="MK" />`} component={Avatar} mdxType="Playground">
  <Avatar text="MK" mdxType="Avatar" />
</Playground>
    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;